import {
  ThreeDPrintOnly,
  CubeCheck,
  Man,
  Game,
  CubeOutline2,
  LowPoly2,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { USE_CASE, POLY_COUNT, POLYGON_TYPE, MATERIAL, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

// `id` doubles as the translation key segment: title/description live under
// `leftSide.useCase.options.<id>` in the three-d-studio locale bundles and are
// resolved by consumers via useTranslation.
export const useCaseOptions = [
  {
    id: USE_CASE.STANDARD,
    icon: CubeCheck,
    preset: {
      polyCount: POLY_COUNT.HIGH,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.PBR,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.HERO,
    icon: Man,
    preset: {
      polyCount: POLY_COUNT.HIGH,
      polygonType: POLYGON_TYPE.QUADRILATERAL,
      material: MATERIAL.PBR,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.PROP,
    icon: Game,
    preset: {
      polyCount: POLY_COUNT.MEDIUM,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.PBR,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.THREE_D_PRINT,
    icon: ThreeDPrintOnly,
    preset: {
      polyCount: POLY_COUNT.HIGH,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.BASIC,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.SHAPE_ONLY,
    icon: CubeOutline2,
    preset: {
      polyCount: POLY_COUNT.HIGH,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.GEOMETRY_ONLY,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.LOW_POLY,
    icon: LowPoly2,
    preset: {
      material: MATERIAL.PBR,
      isSmartLowPoly: true,
      provider: PROVIDER.TRIPO3D,
      targetPolycount: 20000,
    },
  },
]
